import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { services } from '../data/mock';

const ServicesSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="bg-black py-16 lg:py-20 px-6 lg:px-24"
    >
      <div className="max-w-7xl xl:max-w-8xl mx-auto">
        {/* Section Label */}
        <div
          className={`transition-all duration-700 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <h2 className="text-white text-lg tracking-widest font-medium mb-8 lg:mb-12">
            WHAT WE DO
          </h2>
        </div>

        {/* Services List */}
        <div
          className={`transition-all duration-1000 delay-200 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'
          }`}
        >
          <h3
            className="text-white text-4xl lg:text-6xl xl:text-7xl font-spectral leading-tight tracking-wide font-spectral"
            style={{ fontFamily: "'Spectral SC', serif" }}
          >
            {services.map((service, index) => (
              <span key={service}>
                <span className="hover:opacity-60 transition-opacity duration-300 cursor-default">
                  {service}
                </span>
                {index < services.length - 1 && (
                  <span className="inline-block w-2 h-2 bg-white mx-4 lg:mx-6 align-middle" />
                )}
              </span>
            ))}
          </h3>
        </div>

        {/* CTA Button */}
        <div
          className={`mt-12 lg:mt-16 transition-all duration-1000 delay-500 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <Link
            to="/work"
            className="inline-block border border-white text-white px-8 py-3 text-sm tracking-[0.2em] hover:bg-white hover:text-black transition-all duration-500"
          >
            SEE WORK
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
